import {inject, Injectable} from '@angular/core';
import {TodoCompletion, TodoService} from '../../../../api';
import {QueryClient} from '@tanstack/angular-query-experimental';
import {QueryKey} from '../../../constants/query-key';
import {lastValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class TodoCompletionService {
  private readonly todoService = inject(TodoService);
  private readonly queryClient = inject(QueryClient);

  changeTodoCompletion(id: number, completion: TodoCompletion) {
    return lastValueFrom(this.todoService.changeTodoCompletion(id, {completion}));
  }

  invalidateAll() {
    this.queryClient.invalidateQueries({queryKey: [QueryKey.TODOS]});
    this.queryClient.invalidateQueries({queryKey: [QueryKey.DASHBOARD_TODO_STATS]});
  }
}
